export default class CheckNamespaceAdminRequest  {
	/**
	 * * Ид неймспейса
	 */
	NamespaceId!: string;
	/**
	 * * Ид юзера
	 */
	UserId!: number;
	constructor(obj?: Partial<CheckNamespaceAdminRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
